import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles, Button } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const useStyles = makeStyles(theme => ({
   backButton: {
      margin: theme.spacing(0.5, 0),
      padding: theme.spacing(0.5),
      color: '#9EA0A5'
   }
}))

function BackButton({ to }) {
   const classes = useStyles()
   const history = useHistory()

   function handleClick() {
      if (to) {
         history.push(to)
      } else {
         history.goBack()
      }
   }

   return (
      <div>
         <Button className={classes.backButton} onClick={handleClick}>
            <ArrowBackIcon fontSize="small" /> Volver
         </Button>
      </div>
   )
}

export default BackButton
